/**
 * KQ4TNV Repeater Technical Specifications
 */

export const REPEATER_INFO = {
  callsign: "KQ4TNV",
  location: "Stafford, Virginia",
  description: "Multi-Mode Digital Repeater on Pi-Star",
  featureDescription: "Featuring XLX reflector with AMBE transcoding, supporting cross-mode communication between DMR, YSF/C4FM, D-STAR, and M17 networks.",
} as const;

export const TECHNICAL_PARAMS = {
  rxFrequency: "441.41250",
  txFrequency: "446.41250",
  colorCode: 1,
  mode: "DMR",
} as const;

export const TIMESLOTS = {
  ts1: {
    name: "Timeslot 1",
    type: "Dynamic",
    description: "Dynamic BrandMeister",
    details: "Connect to various talkgroups on demand",
  },
  ts2: {
    name: "Timeslot 2",
    type: "Static",
    description: "Static link to XLX556 (Module A)",
    details: "Permanent connection to cross-mode reflector",
  },
} as const;

export const TALKGROUPS = {
  local: {
    id: "314452",
    name: "KQ4TNV Local",
    description: "Local-only talkgroup tied to KQ4TNV",
  },
  xlx: {
    id: "6",
    name: "XLX556 Module A",
    timeslot: "TS2",
    description: "Required for cross-mode access",
  },
} as const;

export const DIGITAL_MODES = {
  dmr: {
    name: "DMR",
    fullName: "Digital Mobile Radio",
    supported: true,
    rfAccess: true,
    hotspotAccess: true,
  },
  ysf: {
    name: "YSF/C4FM",
    fullName: "Yaesu System Fusion / C4FM",
    supported: true,
    rfAccess: true,
    hotspotAccess: true,
    note: "WiresX pass-through enabled (NOT official Yaesu WiresX). Uses Pi-Star YSF gateway.",
  },
  dstar: {
    name: "D-STAR",
    fullName: "D-STAR",
    supported: true,
    rfAccess: true,
    hotspotAccess: true,
    note: "D-STAR mode enabled with access to D-STAR reflectors via XLX gateway.",
  },
  m17: {
    name: "M17",
    fullName: "M17 Protocol",
    supported: true,
    rfAccess: true,
    hotspotAccess: true,
    note: "M17 is an open-source digital voice mode that doesn't require proprietary codecs.",
  },
} as const;

export const XLX_REFLECTOR = {
  name: "XLX556",
  module: "A",
  dashboard: "https://xlx556.kq4tnv.net",
  transcoding: {
    enabled: true,
    technology: "AMBE",
    supportedModes: ["DMR", "YSF", "D-STAR", "M17"],
  },
} as const;

export const CONTACT_INFO = {
  email: "repeater@kq4tnv.net",
  website: "https://kq4tnv.net",
} as const;
